import { gql } from '@apollo/client'
export const login = gql`
mutation LoginWithUsernameOrEmail($username: String!, $password: String!) {
    loginWithUsernameOrEmail(username: $username, password: $password) {
      sessionToken
      email
      registeredAt
      username
      access {
        category
      }
    }
  }
`

